import styled from "styled-components";

export const LeadContainer = styled.div<{ isDesktop: boolean }>`
    background-color: #006571;
    padding: 20px;
    color: #fff;
    margin-top: 40px;
    border-radius: ${({ isDesktop }) => (isDesktop ? "16px" : "0px")};
    @media (min-width: 1024px) {
        padding: 60px;
    }
`;

export const LeadTitle = styled.h2`
    margin-bottom: 32px;
    text-align: center;
`;

export const LeadText = styled.p`
    text-align: left;
    margin-bottom: 8px;
`;

export const LeadUl = styled.ul`
    margin-bottom: 8px;
    list-style-type: disc;
    margin-left: 12px;    
`;

export const LeadLi = styled.li`
    
`;

export const ContentContainer = styled.div`
    margin-bottom: 48px;
`;

export const ModalInput = styled.input`
    padding: 12px;
    border-radius: 8px;
    display: block;
    margin-top: 8px;
    width: 100%;
    border: 1px solid var(--color-grey-100);
    background-color: #fff;
    margin-top: 10px;
    font-size: 16px;
    color: var(--color-coal);
    &:focus-visible {
        outline: 2px solid var(--color-orange);
    }
`;

export const Button = styled.a<{ active?: boolean | undefined }>`
    background-color: ${({ active }) => (!active ? "#cccccc" : "var(--color-orange)")} ;
    color:  var(--color-white);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    border-radius: 35px;
    padding: 16px 44px;
    text-decoration: none;
    display: block;
    text-align: center;
    disabled: ${({ active }) => (!active ? "true" : "false")};
    pointer-events: ${({ active }) => (!active ? "none" : "auto")};
    margin-top: 32px;
`;

export const ErrorMessage = styled.p`
    color: var(--color-alert-color);
    text-align: left;
`;

export const PrivacyText = styled.a`
    font-size: 14px;
    text-decoration: underline;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
